/**
* Created by elmer on 29/06/17.
*/
<style>
    .list-complete-item {
        transition: all 1s;
    }
    .list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active for <2.1.8 */ {
        opacity: 0;
        transform: translateY(30px);
    }
    .list-complete-leave-active {
        position: absolute;
    }
</style>

<template>
    <Row type="flex">
        <i-col :xs="24">
            <Row>
                <i-col :xs="24" :md="10">
                    <h2 class="mb15">
                        <Dropdown @on-click="selectCampaign">
                            <a href="javascript:void(0)">
                                <Icon type="gear-b"></Icon>
                                {{ $store.state.selectedCampaign.titulo }}
                                <Icon type="arrow-down-b"></Icon>
                            </a>
                            <Dropdown-menu slot="list">
                                <Dropdown-item
                                        v-for="campaign in $store.state.campaigns"
                                        :key="`opt_dropdown_${campaign.id}`"
                                        :selected="$store.state.selectedCampaign.id === campaign.id"
                                        :name="campaign.id"
                                >
                                    {{ campaign.titulo }}
                                </Dropdown-item>
                            </Dropdown-menu>
                        </Dropdown>
                    </h2>
                </i-col>
                <i-col :xs="24" :md="14">
                    <h2 class="mb15">
                        &nbsp;
                        <i-button type="primary" @click="$router.go(-1)" class="pantallas-header-btn float-right">
                            <Icon type="arrow-left-c" size="18"></Icon>
                            <span class="ml10">Volver</span>
                        </i-button>
                    </h2>
                </i-col>
            </Row>
            <Row type="flex" :gutter="15">
                <i-col :xs="24" :md="16">
                    <h4 v-show="$store.state.selectedCampaign.descripcion" class="mb15">{{ $store.state.selectedCampaign.descripcion }}</h4>
                    <Row type="flex">
                        <i-col :xs="24" :md="12">
                            <!--<Radio-group v-model="view" type="button">
                                <Radio label="grid">Columnas</Radio>
                                <Radio label="table">Tabla</Radio>
                            </Radio-group>-->
                            <i-form ref="formFilter" :model="formFilter" :rules="rulesFilter" inline>
                                <Form-item prop="estado" label="" class="mb10">
                                    <i-select v-model="formFilter.estado" clearable placeholder="Por estado">
                                        <i-option value="1" label="Activo"></i-option>
                                        <i-option value="0" label="Inactivo"></i-option>
                                    </i-select>
                                </Form-item>
                                <Form-item prop="periodo" label="" class="mb10">
                                    <i-select v-model="formFilter.periodo" clearable placeholder="Por período">
                                        <i-option value="0" label="Permanentes"></i-option>
                                        <i-option value="1" label="Vigentes"></i-option>
                                        <i-option value="2" label="Expirados"></i-option>
                                        <i-option value="3" label="Próximamente"></i-option>
                                    </i-select>
                                </Form-item>
                                <Form-item prop="periodo" label="" v-show="formFilter.periodo === '1'" class="mb10">
                                    <Date-picker type="date" placeholder="Fecha" v-model="formFilter.fecha" :clearable="false"></Date-picker>
                                </Form-item>
                            </i-form>
                        </i-col>
                        <i-col :xs="24" :md="12">
                            <span class="float-right mt10">
                                <Checkbox v-model="showAudio">Audio</Checkbox>
                                <Checkbox v-model="showFotos">Fotos</Checkbox>
                                <Checkbox v-model="showVideos">Videos</Checkbox>
                            </span>
                        </i-col>
                    </Row>
                    <Row class="mb10" type="flex" :gutter="10">
                        <i-col :xs="24" :md="16">
                            <Radio-group v-model="view" type="button" style="vertical-align: middle;">
                                <Radio label="grid">
                                    <Icon type="grid" size="18" class="mt5"></Icon>
                                </Radio>
                                <Radio label="table">
                                    <Icon type="navicon" size="18" class="mt5"></Icon>
                                </Radio>
                            </Radio-group>
                            <i-button type="warning" @click="deleteSelectedFiles" :disabled="!selectedFilteredFiles.length || isDisabled" class="pantallas-header-btn ml10">
                                <Icon type="ios-trash" size="18"></Icon>
                                <span class="ml10">Eliminar {{selectedFilteredFiles.length}} archivos</span>
                            </i-button>
                        </i-col>
                        <i-col :xs="24" :md="8">
                            <p class="text-right mt10" style="font-weight: bolder;">Mostrando {{filteredFiles.length}} de {{$store.state.archivos_publicidad.length}} archivos</p>
                        </i-col>
                    </Row>
                    <transition-group name="list-complete" tag="div" class="ivu-row-flex mb10 mrn5 mln5" v-if="view === 'grid'">
                        <div v-for="item in filteredFiles" :key="`col_file_${item.id}`" class="mb10 ivu-col ivu-col-span-xs-12 ivu-col-span-md-8 pl5 pr5 list-complete-item">
                            <Card>
                                <p slot="title">
                                    <Checkbox-group v-model="selectedFiles">
                                        <Checkbox :label="item.id" :disabled="isDisabled">
                                            <span>{{ item.nombre_archivo }}</span>
                                        </Checkbox>
                                    </Checkbox-group>
                                </p>
                                <a @click="openModal(item)">
                                    <span v-if="item.tipo_archivo === 'Foto'">
                                        <img :src="item.archivo" :alt="item.nombre_archivo" style="width:100%;height:75px;object-fit: cover;" />
                                    </span>
                                    <span v-if="item.tipo_archivo === 'Video'">
                                        <div style="width:100%;height:75px;display: flex;flex-direction: column;justify-content: center;align-items: center;background: black;">
                                            <Icon type="ios-play" color="white" size="30"></Icon>
                                        </div>
                                    </span>
                                </a>
                                <p>
                                    <i-switch v-model="item.estado" class="mt10" @on-change="toggleItem($event, item)" :disabled="isDisabled">
                                        <Icon type="android-done" slot="open"></Icon>
                                        <Icon type="android-close" slot="close"></Icon>
                                    </i-switch>
                                    <span class="float-right">
                                        <i-button type="success" size="small" :disabled="isDisabled" class="mt10" @click="editArchivo(item)">
                                            Editar
                                        </i-button>
                                    </span>
                                </p>
                                <p class="mt5">
                                    <Icon type="calendar"></Icon>
                                    <span class="fs12">{{ formatDate(item.fecha_inicio, item.fecha_fin) }}</span>
                                </p>
                            </Card>
                        </div>
                    </transition-group>
                    <!--<Row type="flex" :gutter="10" v-if="view === 'grid'">
                        <i-col v-for="item in filteredFiles" :key="`col_file_${item.id}`" :xs="12" :md="8" class="mb10">
                        </i-col>
                    </Row>-->
                    <Row type="flex" :gutter="10" v-if="view === 'table'">
                        <i-col :xs="24">
                            <Table border :columns="tableColumns" :data="filteredFiles" @on-selection-change="onSelectAll"></Table>
                        </i-col>
                    </Row>
                    <Modal title="Vista Previa" v-model="modalPreviewVisible" ref="modalPreview" @on-ok="onModalClose">
                        <span v-if="selectedItem && selectedItem.tipo_archivo === 'Foto'">
                            <img :src="selectedItem.archivo" :alt="selectedItem.nombre_archivo" style="width:100%;height:auto;object-fit: cover;" />
                        </span>
                        <span v-if="selectedItem && selectedItem.tipo_archivo === 'Video'">
                            <video style="width:100%;height:300px;" controls>
                                <source :src="selectedItem.archivo">
                            </video>
                        </span>
                        <div slot="footer">
                            <Button type="success" size="large" @click="$refs.modalPreview.close()">Aceptar</Button>
                        </div>
                    </Modal>
                </i-col>
                <i-col :xs="24" :md="8">
                    <Card>
                        <p slot="title">
                            <Icon type="plus-round"></Icon>
                            Agregar archivos
                        </p>
                        <i-form :model="form" ref="formPublicidad" :rules="rules">
                            <Form-item prop="nombre" label="Nombre">
                                <i-input v-model="form.nombre" size="large" :disabled="isDisabled"></i-input>
                            </Form-item>
                            <Form-item prop="descripcion" label="Descripción">
                                <i-input v-model="form.descripcion" size="large" type="textarea" :rows="3" :disabled="isDisabled"></i-input>
                            </Form-item>
                            <Form-item prop="texto_audio" label="Texto dictado">
                                <i-input v-model="form.texto_audio" size="large" type="textarea" :rows="3" :disabled="isDisabled"></i-input>
                            </Form-item>
                            <Form-item prop="fecha_inicio" label="Período de vigencia">
                                <Row type="flex" :gutter="15" style="clear: both;">
                                    <i-col :xs="12">
                                        <Date-picker v-model="form.fecha_inicio" :disabled="isDisabled" type="date" placement="top-end" format="dd-MMM" placeholder="Inicio de la vigencia"></Date-picker>
                                    </i-col>
                                    <i-col :xs="12">
                                        <Date-picker v-model="form.fecha_fin" :disabled="isDisabled" type="date" placement="top-end" format="dd-MMM" placeholder="Término de la vigencia"></Date-picker>
                                    </i-col>
                                </Row>
                            </Form-item>
                            <Form-item prop="files" v-if="!isDisabled">
                                <Upload
                                        multiple
                                        type="drag"
                                        :headers="uploadOpts.headers"
                                        name="file"
                                        :onSuccess="uploadOpts.onSuccess"
                                        :onProgress="uploadOpts.onProgress"
                                        :onError="uploadOpts.onError"
                                        :onRemove="uploadOpts.onRemove"
                                        ref="uploader"
                                        :action="uploadOpts.url">
                                    <div style="padding: 20px 0">
                                        <Icon type="ios-cloud-upload" size="52" style="color: #c3282b"></Icon>
                                        <p>Arrastre aquí los archivos que desea agregar</p>
                                    </div>
                                </Upload>
                            </Form-item>
                            <i-button type="primary" size="large" long :loading="isLoading" :disabled="isDisabled" @click="onSubmit" icon="checkmark-round">Guardar</i-button>
                        </i-form>
                    </Card>
                </i-col>
            </Row>
            <Modal title="Editar datos del archivo" v-model="modalEditarVisible" ref="modalEditar" @on-ok="onModalEditarClose" :footerHide="true">
                <div v-if="selectedItem">
                    <publicidad-edit-form :model="selectedItem" @on-close="onModalEditarClose"></publicidad-edit-form>
                </div>
            </Modal>
        </i-col>
    </Row>
</template>

<script>
  import moment from 'moment';
  import { getTipo } from '@/modules/admin/publicidad.utils';
  import PublicidadEditForm from './PublicidadEditForm';

  export default {
    components: {
      'publicidad-edit-form': PublicidadEditForm,
    },
    data() {
      const self = this;
      return {
        self,
        formFilter: {
          estado: '',
          periodo: '',
          fecha: new Date(),
        },
        isLoading: false,
        showAudio: true,
        showFotos: true,
        showVideos: true,
        selectedItem: false,
        modalPreviewVisible: false,
        modalEditarVisible: false,
        rulesFilter: {
          estado: [
            { type: 'string', message: 'Este campo es requerido' },
          ],
          periodo: [
            { type: 'string', message: 'Este campo es requerido' },
          ],
        },
        view: 'grid',
        tableColumns: [
          {
            type: 'selection',
            width: 60,
            align: 'center',
          },
          {
            title: 'V. Previa',
            width: 100,
            align: 'center',
            render(h, params) {
              const childs = [];
              if (params.row.tipo_archivo === 'Foto') {
                childs.push(h('img', {
                  attrs: {
                    src: params.row.archivo,
                  },
                  style: {
                    width: '50px',
                    height: '50px',
                    objectFit: 'cover',
                  },
                }));
              }
              if (params.row.tipo_archivo === 'Video') {
                childs.push(h('div', {
                  style: {
                    width: '100%',
                    height: '50px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: 'black',
                  },
                }, [
                  h('Icon', {
                    props: {
                      type: "ios-play",
                      color: "white",
                      size: "30",
                    },
                  }),
                ]));
              }
              return h('a', {
                on: {
                  click: () => {
                    self.openModal(params.row);
                  },
                },
              }, childs);
            },
          },
          {
            title: 'Nombre',
            key: 'nombre_archivo',
          },
          {
            title: `Vigencia`,
            render: (h, params) => {
              return h('p', [
                h('Icon', {
                  props: {
                    type: 'calendar',
                  },
                }),
                h('span', {
                  style: {
                    fontSize: '12px',
                    marginLeft: '5px',
                  },
                }, [
                  this.formatDate(params.row.fecha_inicio, params.row.fecha_fin),
                ]),
              ]);
            },
          },
          {
            title: 'Estado',
            width: 90,
            align: 'center',
            render(h, params) {
              return h('i-switch', {
                props: {
                  value: params.row.estado,
                  disabled: self.isDisabled,
                },
                class: {
                  mt10: false,
                },
                on: {
                  'on-change': ($event) => {
                    self.toggleItem($event, params.row);
                  },
                },
              }, [
                h('Icon', {
                  props: {
                    type: 'android-done',
                  },
                  slot: 'open',
                }),
                h('Icon', {
                  props: {
                    type: 'android-close',
                  },
                  slot: 'close',
                }),
              ]);
            },
          },
          {
            title: 'Acciones',
            width: 90,
            align: 'center',
            render(h, params) {
              return h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: self.isDisabled,
                },
                class: {
                  mt10: false,
                },
                on: {
                  click() {
                    self.editArchivo(params.row);
                  },
                },
              }, ['Editar']);
            },
          },
        ],
        selectedFiles: [],
        form: {
          nombre: '',
          descripcion: '',
          texto_audio: '',
          fecha_inicio: '',
          fecha_fin: '',
          // files: [],
        },
        rules: {
          nombre: [
            { required: true, type: 'string', message: 'Este campo es requerido' },
          ],
          descripcion: [
            { type: 'string', message: 'Este campo es requerido' },
          ],
          periodo: [
            { type: 'array', message: 'Este campo es incorrecto' },
          ],
          /* files: [
            { type: 'array', min: 1, message: 'Este campo es incorrecto' },
          ],*/
        },
        uploadOpts: {
          url: `${process.env.API_URL}/api/catchFile?tabla=publicidad_archivos`,
          headers: {
            access_token: this.$store.state.jwt,
          },
          onSuccess(resp, file, fileList) {
            console.log('onsuccess', resp, file, fileList);
            // self.form.files.push(resp[0].url_archivo_temporal);
          },
          onError(err, file, fileList) {
            self.$Message.error('Ocurrió un error al enviar el archivo al servidor, inténtelo nuevamente');
          },
          onRemove(file, fileList) {
            /* self.form.files = fileList.filter(e => e.response && e.response.length)
              .map(e => e.response[0].url_archivo_temporal);*/
            const { nombre_temporal } = file.response[0];
            self.$store.dispatch('removeCatchedFile', { nombre_temporal });
              /* .then((resp) => {
                console.log('archivo eliminado', resp);
              }).catch((err) => {
                console.log('error al borrar archivo', err);
              });*/
          },
        },
      };
    },
    beforeCreate() {
      if (!this.$store.state.selectedCampaign) {
        this.$router.replace({
          path: '/admin/campaigns',
        });
      } else {
        this.$store.dispatch('publicidad', {
          campaign: this.$store.state.selectedCampaign,
        });
      }
    },
    methods: {
      formatDate(inicio, fin) {
        if (!inicio && !fin) {
          return 'Permanente';
        }
        console.log(inicio, fin);
        const mInicio = inicio ? moment.tz(`${inicio} 00:00`, 'America/Merida') : null;
        const mFin = fin ? moment.tz(`${fin} 23:59`, 'America/Merida') : null;
        if (inicio && !fin) {
          return `Desde el ${mInicio.format('D [de] MMM')}`;
        }
        if (!inicio && fin) {
          return `Hasta el ${mFin.format('D [de] MMM')}`;
        }
        if (mInicio.format('M') === mFin.format('M')) {
          return `Del ${moment(inicio).format('D')} al ${moment(fin).format('D [de] MMM')}`;
        }
        return `Del ${moment(inicio).format('D [de] MMM')} al ${moment(fin).format('D [de] MMM')}`;
      },
      openModal(item) {
        this.selectedItem = item;
        this.modalPreviewVisible = true;
      },
      editArchivo(item) {
        this.selectedItem = item;
        this.modalEditarVisible = true;
      },
      onModalClose() {
        this.modalPreviewVisible = false;
        this.selectedItem = false;
      },
      onModalEditarClose() {
        this.modalEditarVisible = false;
        this.selectedItem = false;
        this.$forceUpdate();
      },
      toggleItem(estado, item) {
        this.$store.dispatch('togglePublicidad', { item, estado });
      },
      onSelectAll(selection) {
        this.selectedFiles = selection.length > 0 ? selection.map(e => e.id) : [];
      },
      onSubmit() {
        this.$refs.formPublicidad.validate((valid) => {
          if (valid && this.$refs.uploader.fileList.length >= 1) {
            this.isLoading = true;
            const { nombre, descripcion } = this.form;
            const submitting = this.$Message.loading({
              content: 'Por favor espere un momento...',
              duration: 0,
            });
            Promise.all(
              this.$refs.uploader.fileList.map((archivo, index) => this.$store.dispatch('addPublicidad', {
                form: {
                  nombre_archivo: `${nombre} ${index + 1}`,
                  descripcion,
                  fecha_inicio: this.form.fecha_inicio || null,
                  fecha_fin: this.form.fecha_fin || null,
                  archivo: archivo.response[0].url_archivo_temporal,
                  idpublicidad: this.$store.state.selectedCampaign.id,
                  tipo_archivo: getTipo(archivo.response[0].url_archivo_temporal),
                  estado: 1,
                },
              })),
            ).then((resp) => {
              submitting();
              this.$refs.formPublicidad.resetFields();
              this.$refs.uploader.clearFiles();
              this.isLoading = false;
            }).catch((err) => {
              // console.log(err);
              submitting();
              this.$Message.error("Error al enviar los archivos");
              this.isLoading = false;
            });
          } else {
            this.$Message.error("Error al enviar los archivos");
          }
        });
      },
      selectCampaign(campaignId) {
        const campaign = this.$store.state.campaigns.find(e => e.id === campaignId);
        this.$store.commit('setCampaign', campaign);
        this.$store.dispatch('publicidad', {
          campaign,
        });
        this.selectedFiles = [];
      },
      deleteSelectedFiles() {
        const { selectedFiles, selectedFilteredFiles } = this;
        this.$Modal.confirm({
          title: 'Borrar elementos seleccionados',
          content: `Está a punto de borrar ${selectedFilteredFiles.length} elementos, ¿Desea continuar?`,
          onOk: () => {
            Promise.all(selectedFilteredFiles.map((id) => {
              const upload = this.$store.state.archivos_publicidad.find(e => e.id === Number(id));
              return this.$store.dispatch('removePublicidad', { upload });
            })).then((resp) => {
              // console.log(resp);
              this.selectedFiles = selectedFiles.filter((e, index, data) => {
                return selectedFilteredFiles.indexOf(e.id) === -1;
              });
            });
          },
          okText: 'Continuar',
          cancelText: 'Cancelar',
        });
      },
    },
    computed: {
      archivos_publicidad() {
        return this.$store.state.archivos_publicidad;
      },
      filteredFiles() {
        if (!this.archivos_publicidad.length) {
          return [];
        }
        const { showFotos, showVideos, showAudios, selectedFiles } = this;
        const { estado, periodo, fecha } = this.formFilter;
        const now = fecha ? fecha.getTime() : null;
        return this.archivos_publicidad.filter((e) => {
          const fechaInicio = e.fecha_inicio ? moment(`${e.fecha_inicio} 00:00:01`).toDate().getTime() : null;
          const fechaFin = e.fecha_fin ? moment(`${e.fecha_fin} 23:59:59`).toDate().getTime() : null;
          return (
            ((e.tipo_archivo === 'Foto' && showFotos) ||
            (e.tipo_archivo === 'Video' && showVideos) ||
            (e.tipo_archivo === 'Audio' && showAudios)) &&
            (estado === '' || !!Number(estado) === e.estado)
          ) && (
            periodo === '' ||
            (periodo === '0' && e.fecha_inicio === null && e.fecha_fin === null) ||
            (
              periodo === '1' && (
                (e.fecha_inicio === null && e.fecha_fin === null) ||
                (fechaInicio === null && fechaFin !== null && fechaFin >= now) ||
                (fechaFin === null && fechaInicio !== null && fechaInicio <= now) ||
                (now >= fechaInicio && now <= fechaFin)
              )
            ) ||
            (periodo === '2' && fechaFin !== null && now > fechaFin) ||
            (periodo === '3' && (
                (e.fecha_inicio === null && e.fecha_fin === null) ||
                (fechaInicio !== null && now > fechaInicio)
              )
            )
          );
        }).map((e) => {
          return {
            ...e,
            _checked: selectedFiles.indexOf(e.id) !== -1,
          };
        });
      },
      selectedFilteredFiles() {
        if (this.filteredFiles.length > 0 && this.selectedFiles.length > 0) {
          const { selectedFiles } = this;
          return this.filteredFiles.filter(e => selectedFiles.indexOf(e.id) !== -1).map(e => e.id);
        }
        return [];
      },
      isDisabled() {
        return !this.$store.state.selectedCampaign.administra;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// PublicidadDetail.vue?5e4823cc